import styled from 'styled-components';

const HeaderTextDescription = styled.p`
    font-size: 0.8125rem;
    font-weight: 300;
    line-height: 1rem;
    color: rgb(99, 99, 105);
`;

export default HeaderTextDescription;
